import React, { useEffect, useState } from 'react'
import { Typography } from '@material-ui/core';

import TableCustom from '../../../../../../Components/Table';

import { useStyles } from '../styles';
import { formatarReais } from '../../../../../../Utils/utils';

export default function FichaGPS({ dadosEspelho }) {

    const classes = useStyles();
    const [data, setData] = useState([]);

    useEffect(() => {
        setData(dadosEspelho.listaRecolhimento ?? []);
    }, [dadosEspelho])

    const columns = [
        {
            title: "Competência",
            dataIndex: "competencia",
            key: "competencia",
            align: "left",
            width: 80,
            maxWidth: '20%',
            headerRender: (title) => <div style={{ paddingLeft: 12, display: 'flex' }}>
            <Typography style={{ fontSize: 12, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13, paddingLeft: 15 }}>{value}</p>,
        },
        {
            title: "Valor do INSS",
            dataIndex: "retencaoINSS",
            key: "retencaoINSS",
            align: "left",
            width: 80,
            maxWidth: '20%',
            headerRender: (title) => <div style={{ display: 'flex' }}>
            <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value !== '-' ? formatarReais(value) : '-'}</p>,
        },
        {
            title: "",
            dataIndex: "",
            key: "null",
            width: 80,
            render: (value, row) => <p style={{ fontSize: 13 }}>{''}</p>,
        },
    ];

    const propsTable = {
        columns,
        data,
        heightBody: "140px",
        minHeightBody: "90px",
        marginBorder: false,
        usarMarginBottomContainer: true,
        width: '98%',
        hideBorderBottom: true,
        ativarHoverLinha: false,
        elevationPaper: 0,
        optionsToolbar: {
            info: (
                <div className={classes.header}>
                    <div className={classes.col1}>
                        <div>
                            <Typography className={classes.headerTitle}>{'Ficha GPS'}</Typography>
                        </div>
                    </div>
                </div>
            ),
        },
    };

    return (
        <>
            {data.length > 0 ?
                <TableCustom {...propsTable} />
                :
                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 16, paddingRight: 8 }}>
                    <div className={classes.header}>
                        <div className={classes.col1}>
                            <div>
                                <Typography className={classes.headerTitle}>{'Ficha GPS'}</Typography>
                            </div>
                        </div>
                    </div>
                    <div style={{marginTop: 10, paddingLeft: 25, marginBottom: 15}}>
                        <Typography style={{fontSize: 13, fontWeight: 500}}>Não há dados a serem informados</Typography>
                    </div>
                </div>
            }
        </>
    )
}
